import type { QueryClient } from 'react-query';

import QUERY_KEYS from 'config/api/QUERY_KEYS';

const invalidateOwnerAssetRopaQueries = async (queryClient: QueryClient, organizationId?: number) => {
  await queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_WORKSPACE, organizationId]);
  await queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE, organizationId]);
  await queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE_METRICS, organizationId]);
  await queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE_DETAIL, organizationId]);
  await queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_AVAILABLE_PROCESSING_ACTIVITIES, organizationId]);
};

export default invalidateOwnerAssetRopaQueries;
